/**
 * `DocFoot` — the demo's `docfoot()` (demo line 1491): the legal line on the
 * left, the reference and the copy-control statement on the right.
 *
 * A controlled document says where the controlled copy lives; a generated one
 * says what generated it. UI layer.
 */

import { legalLine, OEM_PRODUCT } from './doc-identity';
import { useOemDocIdentity } from './useOemDocIdentity';

export function DocFoot({ docId, controlled = true }: { docId?: string; controlled?: boolean }) {
  const oem = useOemDocIdentity();
  const control = controlled
    ? `Controlled copy in the ${oem.name} technical library — uncontrolled when printed`
    : `Generated by ${OEM_PRODUCT.name} — the ${OEM_PRODUCT.desc.toLowerCase()}`;
  return (
    <div
      className="docfoot mt-4 flex flex-wrap justify-between gap-3 border-t pt-1.5 text-[10px]"
      style={{ borderColor: 'var(--hairline)', color: 'var(--ink-tertiary)' }}
    >
      <span>{legalLine(oem)}</span>
      <span>
        {docId ? `${docId} · ` : ''}
        {control}
      </span>
    </div>
  );
}
